import { ChannelUsage } from '@core/models';
import { AttributeRead } from '@root/app/store/installation-attributes.store';

// Other installations the device feeds, or null while the read is loading or has failed.
export function otherInstallations(
  read: AttributeRead<ChannelUsage>,
  installationOid: string,
): number | null {
  if (read.state !== 'loaded') return null;
  return new Set(
    read.value.usages.map(usage => usage.installationOid).filter(oid => oid !== installationOid),
  ).size;
}
